import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class AdminService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }


    getUserList(request: Models.IAdvancedSearchModel) {
        return this.toRLService<Models.AdvancedSearchResult>("/api/admin/SearchDivUsers").postSearch(request).$promise;
    }

    getEntityIndexInfo() {
        return this.toRLService<Models.IEntityIndexInfo>("/api/admin/GetEntityIndexInfo").get().$promise;
    }

    rebuildIndex(charTypeIDs: number[], divisionIDs: number[], entityIDs: string[], offsetRecID: number, clearMatchingDocs: boolean) {
        var data: Models.IRebuildIndexRequest = {
            charTypeIDs: charTypeIDs,
            clearMatchingDocs: clearMatchingDocs,
            divisionIDs: divisionIDs,
            entityIDs: entityIDs,
            offsetRecID: offsetRecID
        };
        return this.toRLService<Models.IJobResponse>("/api/admin/rebuildindex").post(data).$promise;
    }

    zipRebuildIndex(charTypeIDs: number[], divisionIDs: number[], offsetRecID: number) {
        var data: Models.IZipRebuildIndexRequest = {
            charTypeIDs: charTypeIDs,
            divisionIDs: divisionIDs,
            offsetRecID: offsetRecID
        };
        return this.toRLService<Models.IJobResponse>("/api/admin/ziprebuildindex").post(data).$promise;
    }

    rebuildEntitiesStatusIndex(divisionID: number, processID: number, statusID: number) {
        var data: Models.IRebuildEntitiesStatusIndexRequest = {
            divisionID: divisionID,
            processID: processID,
            statusID: statusID
        };
        return this.toRLService<Models.IJobResponse>("/api/admin/RebuildEnityStatusIndex").post(data).$promise;
    }

    rebuildEntitiesTemplateIndex(divisionID: number, charTypeID: number, templateID: number) {
        var data: Models.IRebuildEntitiesTemplateIndexRequest = {
            divisionID: divisionID,
            charTypeID: charTypeID,
            templateID: templateID
        };
        return this.toRLService<Models.IJobResponse>("/api/admin/RebuildEnityTemplateIndex").post(data).$promise;
    }

    getJobState(jobID: string) {
        var data = {
            jobID: jobID
        };
        return this.toRLService<Models.IJobState>("/api/admin/getjobstate").get(data).$promise;
    }

    cancelJob(jobID: string) {
        var data = {
            jobID: jobID
        };
        return this.toRLService<void>("/api/admin/canceljob").post(data).$promise;
    }

    processAlertNotifications(jobID: string) {
        var data = {
            jobID: jobID
        };

        return this.toRLService<boolean>("/api/admin/processalertnotifications").post(data).$promise;
    }

    processDailyDigest(jobID: string, desiredDivs: string, dailyDigestEmails: string, dailyDigestRoles: string, desiredStartDate: Date, desiredEndDate: Date, desiredColumnsToExclude: string, desiredStatusID: number, emailType: number) {
        var data = {
            jobID: jobID,
            desiredDivs: desiredDivs,
            desiredEmails: dailyDigestEmails,
            desiredRoles: dailyDigestRoles,
            desiredStartDate: desiredStartDate,
            desiredEndDate: desiredEndDate,
            desiredColumnsToExclude: desiredColumnsToExclude,
            desiredStatusID: desiredStatusID,
            emailType: emailType
        };

        return this.toRLService<boolean>("/api/admin/processdailydigest").post(data).$promise;
    }

    getJobMessages(jobID: string, messageTypeID: number, start: number = 0, take: number = 20) {
        var data = {
            jobID: jobID,
            messageTypeID: messageTypeID,
            start: start,
            take: take
        };
        return this.toRLService<Models.IJobMessageList>("/api/admin/getjobmessages").get(data).$promise;
    }

    getJobs() {
        return this.toRLService<Models.IJobState>("/api/admin/getjobs").query().$promise;
    }

    deleteJobInfo(jobID: string) {
        var data = {
            jobID: jobID
        };
        return this.toRLService<void>("/api/admin/deletejobinfo").post(data).$promise;
    }

    clearCacheForDiv() {
        return this.toRLService<void>("/api/admin/clearcachefordiv").post().$promise;
    }

    refreshCache(pattern: string) {
        var data = {
            pattern: pattern
        };
        return this.toRLService<void>("/api/admin/refreshcache").post(data).$promise;
    }

    benchmarkCache(divID: number, charTypeID: number, recordCount: number) {
        var data = {
            benchDivID: divID,
            benchCharTypeID: charTypeID,
            recordCount: recordCount
        };
        return this.toRLService<Models.IBenchmarkResult>("/api/admin/benchmarkcache").post(data).$promise;
    }

    validateEmail(email: string) {
        var data = {
            email: email
        };
        return this.toRLService<{ success: boolean }>("/api/admin/UniqueEmail").get(data).$promise;

    }

    passwordReset(userRecordID: number, email: string) {
        var data = {
            userRecordID: userRecordID,
            userEmail: email
        }
        return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/resetpassword").post(data).$promise;
    }

    inviteNewUser(existingUserEntityID: string, email: string, title: string, templateID: number, appUrlIDs: number[], roleIDs: number[], roleIdentityIDs: string[]) {
        var data = {
            entityID: existingUserEntityID,
            email: email,
            entityTitle: title,
            templateID: templateID,
            appUrlIDs: appUrlIDs,
            roleIDs: roleIDs,
            identityRoleIDs: roleIdentityIDs
        };
        return this.toRLService<Models.ICreateEntityResponse>("/api/admin/invitenewuser").post(data).$promise;
    }

    updateUserSecurity(contactID: string, email: string, appUrlIDs: number[], roleIDs: number[], identityRoleIDs: string[]) {
        var data = {
            contactID: contactID,
            email: email,
            appUrlIDs: appUrlIDs,
            roleIDs: roleIDs,
            identityRoleIDs: identityRoleIDs
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/updateUserSecurity").post(data).$promise;
    }

    deleteUser(entityID: string) {
        var data = {
            id: entityID
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/DeleteUser/:id", { id: "@id" }).post(data).$promise;
    }

    resyncRecalcAvails(mode: number, divIDs: number[], resync: boolean, recalc: boolean, flags: number) {
        var data = {
            divIDs,
            resync,
            recalc,
            mode,
            flags
        };
        return this.toRLService<Models.IJobResponse>("/api/admin/resyncrecalcavails").post(data).$promise;
    }

    getDivAvailsInfoList() {
        return this.toRLService<Models.IDivAvailsInfo>("/api/admin/getdivavailsinfolist").getArray().$promise;
    }

    syncDivInfo(divID: number) {
        return this.toRLService<boolean>("/api/admin/syncdivinfo").post(divID).$promise;
    }

}